// Simple module-level cache for the static case info endpoint
// (/listcasesinfo.webapi). Memoizes the in-flight/resolved request so the
// network call only ever fires once per login, no matter how many times or
// where fetchCaseInfo() is called from. clearCaseInfoCache() is called on
// logout so the next login fetches a fresh copy instead of reusing this
// session's cached result.

let cachedPromise = null;

export const fetchCaseInfo = (route, token) => {
  if (!cachedPromise) {
    cachedPromise = fetch(`${route}/listcasesinfo.webapi`, {
      method: "GET",
      headers: {
        Token: token,
      },
    })
      .then((response) => {
        if (response.status === 401) {
          throw new Error("Authentication Error");
        }
        return response.text();
      })
      .then((text) => JSON.parse(text))
      .catch((error) => {
        // Don't cache failures - let the next caller retry the fetch.
        cachedPromise = null;
        throw error;
      });
  }

  return cachedPromise;
};

export const clearCaseInfoCache = () => {
  cachedPromise = null;
};
